<script>
  import TierBadge from './TierBadge.svelte';
  import ICUBadge from './ICUBadge.svelte';
  import { getSortByString } from '../../utils/sorters';

  export let selectedCountyClosures;
  export let selectedCountyMetrics;

  function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
  }

  Math.ceil10 = function (value, exp) {
    return decimalAdjust('ceil', value, exp);
  };

  const tierDescriptions = {
    '1': 'Most nonessential indoor business operations are closed',
    '2': 'Some nonessential indoor business operations are closed',
    '3': 'Some business operations can open with modifications',
    '4': 'Most business operations can open with modifications',
  };
</script>

<div
  class="status_card status_{selectedCountyClosures.tier}"
  data-value={selectedCountyClosures.county}
  id="card_{selectedCountyClosures.fips}"
>
  <p class="countyname status_{selectedCountyClosures.tier}">
    {selectedCountyClosures.county} County
  </p>
  <div class="status_bullet_list">
    <p class="overall_status">
      <span class="category_big">Tier {selectedCountyClosures.tier}</span>
      <span class="category_detail_big"
        >{selectedCountyClosures.tier_label} risk</span
      >
    </p>
    <div class="tier_description">
      {tierDescriptions[selectedCountyClosures.tier]}
    </div>
    <hr />
    <h3>The metrics</h3>
    <div class="badge-row">
      <div class="badge-wrapper">
        <div class="badge-head">Regional<br />ICU Capacity</div>
        <div id="closures-icu-capacity-chart" class="badge-chart">
          <ICUBadge bind:value={selectedCountyClosures.icu_capacity} />
        </div>
      </div>
      <div class="badge-wrapper">
        <div class="badge-head">Adjusted<br />case rate</div>
        <div id="closures-adjusted-case-rate-chart" class="badge-chart">
          <TierBadge
            bind:value={selectedCountyMetrics.adjusted_case_rate}
            thresholds={[2, 6, 10]}
            valueFormat={(v) => `${v.toFixed(1)}`}
            maxValue={selectedCountyMetrics.adjusted_case_rate < 10
              ? 15
              : Math.ceil(selectedCountyMetrics.adjusted_case_rate * 1.33)}
          />
        </div>
      </div>
      <div class="badge-wrapper">
        <div class="badge-head">Positive<br />test rate</div>
        <div id="closures-positivity-rate-chart" class="badge-chart">
          <TierBadge
            bind:value={selectedCountyMetrics.positivity_rate}
            thresholds={[0.02, 0.05, 0.08]}
            valueFormat={(v) => `${(v * 100).toFixed(1)}%`}
            maxValue={selectedCountyMetrics.positivity_rate > 0.1
              ? Math.ceil10(selectedCountyMetrics.positivity_rate, -1)
              : 0.1}
          />
        </div>
      </div>
      {#if selectedCountyMetrics.equity_index}
        <div class="badge-wrapper">
          <div class="badge-head">Equity<br />index</div>
          <div id="cclosures-equity-index-chart" class="badge-chart">
            <TierBadge
              bind:value={selectedCountyMetrics.equity_index}
              thresholds={[2.1, 5.2, 8.0]}
              valueFormat={(v) => `${v.toFixed(1)}`}
              maxValue={selectedCountyMetrics.equity_index < 10
                ? 10
                : Math.ceil(selectedCountyMetrics.equity_index + 2)}
            />
          </div>
        </div>
      {/if}
    </div>
    <hr />
    <h3>What's open and closed</h3>
    <div class="columns">
      <ul>
        {#each selectedCountyClosures.bullet_list as obj}
          <li>
            <span class="category">{obj.name}</span>
            <span class="category_detail">{obj.status}</span>
          </li>
        {/each}
      </ul>
    </div>
  </div>
</div>
